module.exports = __webpack_public_path__ + "static/media/cvfy.cc8435a3.jpg";